/**
 * OpenhomeCard
 * 
 * @Author: Focci
 * @Date: 2023-08-08 21:15:28
 * @Last Modified by: Focci
 * @Last Modified time: 2023-08-08 21:15:28
 */

'use client'

import PropTypes from 'prop-types'
import useDialog from '@hook/useDialog'
import useTracking from '@hook/useTracking'
import { isFunction } from 'lodash-es'
import { useCallback, useRef } from 'react'
import AddCalendarReminder from './AddCalendarReminder'
import OpenhomeCardAction from './OpenhomeCardAction'
import OpenhomeCardBody from './OpenhomeCardBody'
import useOpenhome from './useOpenhome'

export default function OpenhomeCard({
  type = 2, // 2 开放日; 3 拍卖
  data = {},
  house = {}
}) {
  const refReminder = useRef()
  const { openDialog, closeDialog, Dialog } = useDialog()
  const { handleClick, isAuction, added, isLoading } = useOpenhome({ type, data, house })
  const { pushTrackListingClick } = useTracking()

  const handleOpenhomeClick = useCallback(() => {
    pushTrackListingClick(type === 2 ? 'open_home-add_calendar' : 'auction-add_calendar', house)
    handleClick(() => openDialog())
  }, [pushTrackListingClick, type, house, handleClick, openDialog])

  // 关闭弹出框
  const handleClose = useCallback(() => {
    const { sendEmailToAgent } = refReminder.current

    closeDialog()
    isFunction(sendEmailToAgent) && sendEmailToAgent()
  }, [closeDialog])

  return (
    <>
      <div className="border rounded-sm flex items-center gap-x-4 p-3">
        <OpenhomeCardBody data={data} auction={isAuction} />
        <OpenhomeCardAction
          loading={isLoading}
          added={added}
          auction={isAuction}
          onClick={handleOpenhomeClick}
        />
      </div>
      <Dialog onClose={handleClose}>
        <AddCalendarReminder
          auction={isAuction}
          data={data}
          house={house}
          ref={refReminder}
        />
      </Dialog>
    </>
  )
}

OpenhomeCard.propTypes = {
  type: PropTypes.number,
  data: PropTypes.object,
  house: PropTypes.object,
}
